import CenterLayout from "./CenterLayout";

export default CenterLayout;
